import * as FIELD_NAME from 'constant/form-item-names'
import * as RULES from 'constant/form-rules'
import * as NUMBER from 'constant/number'
import React from 'react'
import { Form, Input } from 'antd'
import styles from '../styles.scss'

const FileNameInput = () => {
  return (
    <Form.Item
      name={FIELD_NAME.FILE_NAME}
      rules={[RULES.REQUIRED, RULES.maxCharLength(NUMBER.ONE_HUNDRED)]}
    >
      <Input
        className={styles.form_input}
        placeholder={'Title'}
      />
    </Form.Item>
  )
}

export default FileNameInput
